module.exports = new __parcel__URL__("army_modal_close_button.d0d5b07d.png").toString();